export default {
    // 用户使用方式
    USAGE_MODE: 'usage_mode',
    MEMBER_SEARCH: 'member_search',
    // 部门成员-搜索结果全选-勾选
    MEMBER_SEARCH_RESULT_ALL_CHECK: 'member_search_result_all_check',
    // 部门成员-查看已选全部
    MEMBER_VIEW_ALL_SELECTED: 'member_view_all_selected',
    // 部门成员-区域宽度-改变
    MEMBER_WIDTH_CHANGE: 'member_width_change',
    // 部门成员-角色组-勾选
    MEMBER_ROLE_GROUP_CHECK: 'member_role_group_check',
    // 产品更新触达
    UPDATE_LOG_SHOW: 'update_log_show',
    // 产品更新打开
    UPDATE_LOG_OPEN: 'update_log_open',
    // 产品更新关闭
    UPDATE_LOG_CLOSE: 'update_log_close',
    // 运营通知的弹出
    DASH_OPERATION_NOTIFY_SHOW: 'dash_operation_notify_show',
    // 运营通知的点击
    DASH_OPERATION_NOTIFY_CLICK: 'dash_operation_notify_click',
    // 运营通知的关闭
    DASH_OPERATION_NOTIFY_CLOSE: 'dash_operation_notify_close',
    // 点击查看消息管理-运营通知
    OPERATION_NOTIFY_CLICK: 'operation_notify_click',
    // 消息中心tab点击
    MESSAGE_CENTER_TAB_CLICK: 'message_center_tab_click',
    // 消息中心-数据提醒-切换消息分类
    MESSAGE_CENTER_DATA_REMINDER_TAB_CLICK: 'message_center_data_reminder_tab_click',
    // 消息中心-应用日志-切换消息分类
    MESSAGE_CENTER_APP_LOG_TAB_CLICK: 'message_center_app_log_tab_click',
    // 消息中心-文档动态-切换消息分类
    MESSAGE_CENTER_DOC_DYNAMIC_TAB_CLICK: 'message_center_doc_dynamic_tab_click',
    // 消息中心-运营通知-切换消息分类
    MESSAGE_CENTER_OPERATION_NOTIFY_TAB_CLICK: 'message_center_operation_notify_tab_click',
    // 消息中心-通讯录管理-切换消息分类
    MESSAGE_CENTER_CONTACTS_MGMT_TAB_CLICK: 'message_center_contacts_mgmt_tab_click',
    // 消息中心-系统管理-切换消息分类
    MESSAGE_CENTER_SYS_MGMT_TAB_CLICK: 'message_center_sys_mgmt_tab_click',
    /** 成员卡片设置－点击显示成员卡片 */
    MEMBER_CARD_SETTINGS_CLICK: 'member_card_settings_click',
    /** 成员卡片设置－悬浮显示成员卡片 */
    MEMBER_CARD_SETTINGS_HOVER: 'member_card_settings_hover',
    /** 开放平台管理员－点击 */
    OPEN_PLATFORM_ADMIN: 'open_platform_admin',
    /** 开放平台管理员配置－选择成员 */
    OPEN_PLATFORM_ADMIN_SELECT_MEMBER: 'open_platform_admin_select_member',
    /** 开放平台管理员配置－选择成员弹窗－确定/取消 */
    OPEN_PLATFORM_ADMIN_SELECT_MEMBER_DIALOG: 'open_platform_admin_select_member_dialog',
    /** 开放平台管理员配置－确定/取消 */
    OPEN_PLATFORM_ADMIN_CONFIRM: 'open_platform_admin_confirm'
};
